<template>
  <div v-if="!this.$store.state.general.user.verified">
    <plans msgtitle="You currently do not have access to General Data Insights"
            msgdescription="Please choose a plan to pay to enjoy the General Data Insights feature"
      ></plans>
  </div>
  <div v-else>
    <insights :segmentID="$route.params.id" />
  </div>
  
</template>

<script>
  import Insights from '@/components/Insights';
  import Plans from './Plans/Plans'

  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;

  export default {
    name: 'Dashboard',
    components: { Insights, Plans },
    mounted(){
      // console.log("Verified user is", this.$store.state.general.user.verified);
      
      // if(!this.$store.state.general.user.verified){
      //     window.location = '/plans';

      //   Swal.fire({
      //   icon: 'error',
      //   title: 'Sorry...',
      //   text: 'You do not have access to this feature now, choose a plan and pay.',
      //   }).then((result)=>{
      //   if(result){
      //     window.location = '/plans';

      //   }else{
      //     window.location = '/plans';

      //   }
      // })
      
    },
  };
</script>
